import {ScrollHandler} from "../utils/_scroll-handler";

export default function VideoSection () {
  PlayOnClick()
  AutoPlayOnScroll()
}

function PlayOnClick () {
  const PLAY_BUTTONS = document.querySelectorAll('.play-button')
  if (PLAY_BUTTONS.length > 0) {
    for (let i = 0; i < PLAY_BUTTONS.length; i++) {
      const PLAY_BUTTON = PLAY_BUTTONS[i]
      const VIDEO = PLAY_BUTTON.parentNode.querySelector('video')
      VIDEO && PLAY_BUTTON.addEventListener('click', () => {
        VIDEO.play()
        PLAY_BUTTON.parentNode.removeChild(PLAY_BUTTON)
      })
    }
  }
}

function AutoPlayOnScroll () {
  const VIDEOS = document.querySelectorAll('.autoplay-video')
  if (VIDEOS.length > 0) {
    for (let i = 0; i < VIDEOS.length; i++) {
      const VIDEO = VIDEOS[i]
      const scrollHandler = new ScrollHandler({
        el: VIDEO,
        onEnter: () => VIDEO.play()
      })
      scrollHandler.init()
    }
  }
}